<template>
    <g-typography v-if="duration > 0" :value="countdownText" v-bind="$attrs" />
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from 'vue-demi';
import moment from 'moment';
import { pluralize } from '../../../../../helpers/string-helpers';

export default {
    name: 'ActivationBriefSubmissionCountdown',
    props: {
        endDatetime: {
            type: String,
            required: true,
        },
        prefix: {
            type: String,
            default: 'Opens in',
        },
    },
    setup(props, { emit }) {
        const duration = ref(null);
        const interval = 500;
        let intervalRef = null;

        const countdownText = computed(() => {
            const d = duration.value?.days() ?? 0;
            const h = duration.value?.hours() ?? 0;
            const m = duration.value?.minutes() ?? 0;
            const s = duration.value?.seconds() ?? 0;

            const getText = (value, unit) => `${value} ${pluralize(value, unit)}`;

            const durationText = (
                duration.value?.asHours() >= 24
                    ? [getText(d, 'day'), getText(h, 'hour'), getText(m, 'minute')]
                    : [getText(h, 'hour'), getText(m, 'minute'), getText(s, 'second')]
                ).join(' ');

            return `${props.prefix} ${durationText}`;
        }, [duration]);

        const decrementDuration = () => {
            duration.value = moment.duration(moment(props.endDatetime).diff(moment()));

            intervalRef = setInterval(() => {
                duration.value = moment.duration(moment(props.endDatetime).diff(moment()));

                if (duration.value <= 0) {
                    emit('countdown-complete');
                    clearInterval(intervalRef);
                }
            }, interval);
        };

        onMounted(() => {
            decrementDuration();
        });

        onUnmounted(() => {
            clearInterval(intervalRef);
        });

        return {
            duration,
            countdownText,
        };
    },
};
</script>
